export const EXPERIENCE_PATH = "/experience";
export const EXPERIENCE_LIST = "/experiences";
export const EXPERIENCE_ROUTE_PATH = `${EXPERIENCE_PATH}/:experienceId/:slug?`;
